import React from 'react';
import PropTypes from 'prop-types';
import { Image, Text, H3, MarkdownWrapper } from 'components/atoms';
import './SizeGuideCard.scss';

const SizeGuideCard = ({
	title,
	description,
	size,
	content,
	imageSrc,
	imageAlt,
	contentAlign,
	removeMinHeight,
}) => {
	return (
		<div className="size-guide-card">
			<div
				className={`card-header ${removeMinHeight ? 'fit-content-height' : ''}`}
			>
				{imageSrc && (
					<Image
						src={imageSrc}
						alt={imageAlt}
						className="card-icon"
						lazyLoading={true}
					/>
				)}

				<H3
					className="card-title"
					weight="extraBold"
					size="medium"
					color="black"
				>
					{title}
				</H3>
				{description && (
					<Text
						className="card-description"
						size="smallMedium"
						weight="standard"
						color="darkGray"
					>
						{description}
					</Text>
				)}

				{size && (
					<div className="card-size">
						<Text
							size="smallMedium"
							weight="standard"
							color="black"
						>
							{size}
						</Text>
					</div>
				)}
			</div>

			<div className="card-blue-section">
				<div className="blue-block">
					<MarkdownWrapper
						className={contentAlign}
						content={[{ value: content }]}
					/>
				</div>
			</div>
		</div>
	);
};

SizeGuideCard.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	size: PropTypes.string,
	content: PropTypes.string.isRequired,
	imageSrc: PropTypes.string,
	imageAlt: PropTypes.string,
	contentAlign: PropTypes.oneOf(['text-left', 'text-center', 'text-right']),
	removeMinHeight: PropTypes.bool,
};

SizeGuideCard.defaultProps = {
	imageAlt: 'storage unit',
	size: '',
	contentAlign: 'text-center',
};

export default SizeGuideCard;
